<app-dialog-template
[ngClass]="data?.hideCancelButton ? 'c-license-notification__confirmation-dialog-height-fix': ''">
  <app-dialog-template-header>
    <app-dialog-template-icon
      [name]="'alert'"
      [color]="DialogTemplateIconColorEnum.PRIMARY">
    </app-dialog-template-icon>
    <app-dialog-template-title>{{ data.title }}</app-dialog-template-title>
    <app-dialog-template-header-actions></app-dialog-template-header-actions>
  </app-dialog-template-header>

  <app-dialog-template-body>
    <pre class="c-confirmation-dialog__body" [innerHTML]="data.description"></pre>
  </app-dialog-template-body>

  <app-dialog-template-footer>
    <app-bui-button-label *ngIf="!data.hideCancelButton"
      [comboStyle]="DialogTemplateButtonComboStyleEnum.OUTLINE"
      (clickEvent)="onAction(false)">
      {{ data.noButtonText }}
    </app-bui-button-label>
    <app-bui-button-label
      [comboStyle]="!data.hideCancelButton ? DialogTemplateButtonComboStyleEnum.FILL_GRADIENT_1 :  DialogTemplateButtonComboStyleEnum.OUTLINE"
      (clickEvent)="onAction(true)">
      {{ data.yesButtonText }}
    </app-bui-button-label>
  </app-dialog-template-footer>
</app-dialog-template>
